import React, {createContext, useState, useEffect, useContext, useMemo} from "react"

interface IInputContext {
    lastInput: "keyboard" | "mouse"
    lastInputShiftPressed: boolean
}

const InputContext = createContext<IInputContext>({
    lastInput: "mouse",
    lastInputShiftPressed: false,
})

export const InputContextProvider = ({children}) => {
    const [lastInput, setLastInput] = useState<"mouse" | "keyboard">("mouse")
    const [lastInputShiftPressed, setLastInputShiftPressed] = useState(false)

    useEffect(() => {
        const keyboardListener = (ev: KeyboardEvent) => {
            setLastInput("keyboard")
            setLastInputShiftPressed(ev.shiftKey)
        }
        const mouseListener = () => setLastInput("mouse")
        document.addEventListener("keydown", keyboardListener)
        document.addEventListener("mousedown", mouseListener)

        return () => {
            document.removeEventListener("keydown", keyboardListener)
            document.removeEventListener("mousedown", mouseListener)
        }
    }, [])

    const contextValue = useMemo(() => ({lastInput, lastInputShiftPressed}), [lastInput, lastInputShiftPressed])

    return <InputContext.Provider value={contextValue}>{children}</InputContext.Provider>
}

export const useInputContext = () => useContext(InputContext)
